import { render, staticRenderFns } from "./ModalDelete.vue?vue&type=template&id=32f0b80b&"
import script from "./ModalDelete.vue?vue&type=script&lang=ts&"
export * from "./ModalDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports